import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { setVueApp, setStore } from "@/services/shared";
import analyticMixin from "@/mixins/has-analytic";
import "@/services/prototype";
import "@/services/gtm";
import "@/services/pendoSetup";
import { initializePendo } from "@/services/pendoInit";
import { VENDOR_ROLE } from "@/services/constants";

Vue.config.productionTip = false;

// decode isn't normally necessary since 99% of the case they are already decoded by proteus,
// however there's a special case of entering a 2nd level route: #/account#w9 that proteus isn't properly
// decoding for us, so we need to manually do it here
window.location = decodeURIComponent(window.location.href);

// global mixin for all components
Vue.mixin(analyticMixin);

Vue.mixin({
  methods: {
    isFeatureEnabled(feature) {
      return this.$store.getters["featureFlags/getFlag"](feature);
    }
  }
});

// set store instance globally for accessing in services
setStore(store);

const initVueApp = user => {
  const vueapp = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount("#app");

  // set the vue app instance globally for accessing in services
  setVueApp(vueapp);

  if (
    window.location.href.endsWith("/v2/#/vendor/login") ||
    window.location.href.endsWith("/v2/#/vendor/create-account") ||
    (user && Symbol.for(user.role) === VENDOR_ROLE)
  ) {
    import("@/services/salesforce-chat");
  }

  //user won't be initialized when app first loads,
  //but will exist if user clicks browser refresh button
  initializePendo(user[0]);
};

Promise.all([
  store.dispatch("user/loadCurrentUser"),
  store.dispatch("featureFlags/fetchFlags")
]).then(initVueApp);
